import React from 'react';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from './ToggleView.module.scss';

export enum DisplayStyle {
    COLUMNS = 'columns',
    ROWS = 'rows',
    PIVOT = 'pivot',
}

interface Props {
    displayStyle: string;
    setDisplayStyle: (value: DisplayStyle) => void;
}

export const ToggleView = ({ displayStyle = DisplayStyle.COLUMNS, setDisplayStyle }: Props) => {
    const handleToggled = (value: DisplayStyle) => {
        if (displayStyle !== value) {
            setDisplayStyle(value);
        }
    };

    return (
        <div className={classes.toggleViewContainer}>
            <div
                className={`${classes.IconWrapper} ${classes.columns}  ${
                    displayStyle === DisplayStyle.COLUMNS ? classes.active : ''
                }`}
                onClick={() => {
                    handleToggled(DisplayStyle.COLUMNS);
                }}
            >
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'Board View'}
                    triggerElement={<Icon name={'columns'} size={'12px'} />}
                />
                <div data-testid={'board-button'} className={classes.toggleButtonText}>
                    Board
                </div>
            </div>
            <div
                className={`${classes.IconWrapper} ${classes.rows} ${
                    displayStyle === DisplayStyle.ROWS ? classes.active : ''
                }`}
                onClick={() => {
                    handleToggled(DisplayStyle.ROWS);
                }}
            >
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'List View'}
                    triggerElement={<Icon name={'rows'} title={''} />}
                />
                <div data-testid={'list-button'} className={classes.toggleButtonText}>
                    List
                </div>
            </div>
            <div
                className={`${classes.IconWrapper} ${classes.pivot} ${
                    displayStyle === DisplayStyle.PIVOT ? classes.active : ''
                }`}
                onClick={() => {
                    handleToggled(DisplayStyle.PIVOT);
                }}
            >
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'Pivot View'}
                    triggerElement={<MuiIcon color={'inherit'} fontSize={'2.5rem'} icon={'pivot_table_chart'} />}
                />
                <div data-testid={'pivot-button'} className={classes.toggleButtonText}>
                    Pivot
                </div>
            </div>
        </div>
    );
};
